module.exports = __webpack_public_path__ + "static/img/s121.c9fb175f.png";